import { privileges } from 'Components/constants/appConstants';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Navdata = () => {
    const history = useNavigate();
    // state data
    const [isDashboard, setIsDashboard] = useState<boolean>(false);
    const [isApps, setIsApps] = useState<boolean>(false);
    const [isAuth, setIsAuth] = useState<boolean>(false);
    const [isPages, setIsPages] = useState<boolean>(false);
    const [isBaseUi, setIsBaseUi] = useState<boolean>(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState<boolean>(false);
    const [isForms, setIsForms] = useState<boolean>(false);
    const [isTables, setIsTables] = useState<boolean>(false);
    const [isCharts, setIsCharts] = useState<boolean>(false);
    const [isIcons, setIsIcons] = useState<boolean>(false);
    const [isMaps, setIsMaps] = useState<boolean>(false);
    const [isMultiLevel, setIsMultiLevel] = useState<boolean>(false);
    const [iscurrentState, setIscurrentState] = useState('Dashboard');
    const [isArea, setIsArea] = useState<boolean>(false);
    const [isUserManagement, setIsUserManagement] = useState<boolean>(false);
    const [isLogs, setIsLogs] = useState<boolean>(false);
    const [isEmployeeId, setIsEmployeeId] = useState<boolean>(false);
    const [isDepartments, setIsDepartments] = useState<boolean>(false);

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute('sub-items')) {
            const ul: any = document.getElementById('two-column-menu');
            const iconItems: any = ul.querySelectorAll('.nav-icon.active');
            const activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove('active');
                const id = item.getAttribute('sub-items');
                const getID = document.getElementById(id) as HTMLElement;
                if (getID) getID.classList.remove('show');
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        if (iscurrentState !== 'Charts') {
            setIsCharts(false);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        if (iscurrentState !== 'MuliLevel') {
            setIsMultiLevel(false);
        }
        if (iscurrentState === 'Widgets') {
            history('/widgets');
            document.body.classList.add('twocolumn-panel');
        }
        if (iscurrentState === 'Area') {
            setIsArea(false);
        }
        if (iscurrentState === 'userManagement') {
            setIsUserManagement(false);
        }
        if (iscurrentState === 'informationManagement') {
            setIsLogs(false);
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel
    ]);

    const menuItems: any = [
        {
            id: 'dashboard',
            label: 'Dashboard',
            icon: 'ri-dashboard-line',
            image: true,
            link: '/dashboard',
            view: privileges.DASHBOARD.DASHBOARD,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Dashboard');
                updateIconSidebar(e);
                history('/dashboard');
            }
        },
        {
            id: 'Area',
            label: 'Regions & Areas',
            icon: 'ri-honour-line',
            image: true,
            link: '/regions',
            create: privileges.AREAS.ADD_AREAS,
            view: privileges.AREAS.VIEW_AREAS,
            // view: 'VIEW',
            click: function (e: any) {
                e.preventDefault();
                setIsArea(!isArea);
                setIscurrentState('Area');
                updateIconSidebar(e);
                history('/regions');
            }
        },
        {
            id: 'userManagement',
            label: 'User Management',
            create: privileges.USERS.ADD_USERS,
            view: privileges.USERS.VIEW_USERS,
            image: true,
            link: '/user-management',
            click: function (e: any) {
                e.preventDefault();
                setIsUserManagement(!isUserManagement);
                setIscurrentState('userManagement');
                updateIconSidebar(e);
                history('/user-management');
            }
        },
        {
            id: 'informationManagement',
            label: 'Information Management',
            icon: 'ri-honour-line',
            create: privileges.ENTRIES.VIEW_MODIFIED_ENTRIES,
            view: privileges.ENTRIES.VIEW_INFORMATION_MANAGEMENT,
            image: true,
            link: '/information-management',
            click: function (e: any) {
                e.preventDefault();
                setIsLogs(!isLogs);
                setIscurrentState('informationManagement');
                updateIconSidebar(e);
                history('/information-management');
            }
        },
        {
            id: 'EmployeeId',
            label: "Employee ID's",
            icon: 'ri-honour-line',
            create: privileges.EMPLOYEEID.ADD_EMPLOYEE_IDS,
            view: privileges.EMPLOYEEID.VIEW_EMPLOYEE_IDS,
            image: true,
            link: '/employeeId',
            click: function (e: any) {
                e.preventDefault();
                setIsEmployeeId(!isEmployeeId);
                setIscurrentState('EmployeeId');
                updateIconSidebar(e);
                history('/employeeId');
            }
        },
        {
            id: 'clientAreaDashboard',
            label: 'Client Area',
            icon: 'ri-honour-line',
            image: true,
            link: '/clientAreaDashboard',
            view: 'VIEW_CLIENT_AREAS',
            click: function (e: any) {
                e.preventDefault();
                setIsEmployeeId(!isEmployeeId);
                setIscurrentState('EmployeeId');
                updateIconSidebar(e);
                history('/clientAreaDashboard');
            }
        },
        {
            id: 'Departments',
            label: 'Departments',
            icon: 'ri-building-line',
            image: true,
            link: '/departments',
            view: privileges.DEPARTMENTS.DEPARTMENTS, // Temporarily using departments view privilege
            click: function (e: any) {
                e.preventDefault();
                setIsDepartments(!isDepartments);
                setIscurrentState('Departments');
                updateIconSidebar(e);
                history('/departments');
            }
        },
        {
            id: 'adminMapView',
            label: 'Map View',
            icon: 'ri-map-2-line',
            image: true,
            link: '/admin-map-view',
            view: privileges.CLIENT_MAP.ADMIN_MAP_VIEW,
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('adminMapView');
                updateIconSidebar(e);
                history('/admin-map-view', { state: { header: 'hide' } });
            }
        },
        {
            id: 'nodalOfficerMapView',
            label: 'Map View',
            icon: 'ri-map-2-line',
            image: true,
            link: '/nodal-officer-map-view',
            view: privileges.CLIENT_MAP.NODAL_OFFICER_MAP_VIEW,
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('nodalOfficerMapView');
                updateIconSidebar(e);
                history('/nodal-officer-map-view', { state: { header: 'hide' } });
            }
        }
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
